module.exports = __webpack_public_path__ + "static/img/prod_pic06.fa70c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic06.jpg
// module id = vUhj
// module chunks = 4